import React from 'react'

const LogInText = () => {
  return (
    <div className='signin-welcome-text mt-6'>Login to AgroEase</div>
  )
}

export default LogInText